const menuItems = [
  {
    id: 1,
    title: "Panel de Administrador",
    path: "/admin",
    hasSubMenu: false,
  },
  {
    id: 2,
    title: "Mobiliario Central",
    path: "/mobiliario-central",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/mobiliario-central/todo" },
      { id: 2, title: "Munich", path: "/mobiliario-central/munich" },
      { id: 3, title: "Copenhague", path: "/mobiliario-central/copenhague" },
      { id: 4, title: "Miami-Splau", path: "/mobiliario-central/miami" },
      { id: 5, title: "Make Up 400", path: "/mobiliario-central/make-up-400" },
      // { id: 5, title: "General", path: "/mobiliario-central/general" },
      // { id: 6, title: "Tiendas Top", path: "/mobiliario-central/tiendas-top" },
      // { id: 7, title: "Tiendas Light", path: "/mobiliario-central/tiendas-light" },
      // { id: 8, title: "Tiendas Low", path: "/mobiliario-central/tiendas-low" },
    ],
  },
  {
    id: 3,
    title: "Mobiliario Perimetral",
    path: "/mobiliario-perimetral",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/mobiliario-perimetral/todo" },
      { id: 2, title: "Munich", path: "/mobiliario-perimetral/munich" },
      { id: 3, title: "Copenhague", path: "/mobiliario-perimetral/copenhague" },
      { id: 4, title: "Miami-Splau", path: "/mobiliario-perimetral/miami" },
      { id: 5, title: "Make Up 400", path: "/mobiliario-perimetral/make-up-400" },
      // { id: 5, title: "General", path: "/mobiliario-perimetral/general" },
      // { id: 6, title: "Tiendas Top", path: "/mobiliario-perimetral/tiendas-top" },
      // { id: 7, title: "Tiendas Light", path: "/mobiliario-perimetral/tiendas-light" },
      // { id: 8, title: "Tiendas Low", path: "/mobiliario-perimetral/tiendas-low" },
    ],
  },
  {
    id: 4,
    title: "Mesas",
    path: "/mesas",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/mesas/todo" },
      { id: 2, title: "Munich", path: "/mesas/munich" },
      { id: 3, title: "Copenhague", path: "/mesas/copenhague" },
      { id: 4, title: "Miami-Splau", path: "/mesas/miami" },
      { id: 5, title: "Make Up 400", path: "/mesas/make-up-400" },
    ],
  },
  {
    id: 5,
    title: "Probadores",
    path: "/probadores",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/probadores/todo" },
      { id: 2, title: "Munich", path: "/probadores/munich" },
      { id: 3, title: "Copenhague", path: "/probadores/copenhague" },
      { id: 4, title: "Make Up 400", path: "/probadores/make-up-400" },
      { id: 5, title: "Miami-Splau", path: "/probadores/miami" },
      // { id: 6, title: "Tiendas Top", path: "/probadores/tiendas-top" },
      // { id: 7, title: "Tiendas Light/Low", path: "/probadores/tiendas-light-low" },
    ],
  },
  {
    id: 6,
    title: "Caja",
    path: "/caja",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/caja/todo" },
      { id: 2, title: "Munich", path: "/caja/munich" },
      { id: 3, title: "Copenhague", path: "/caja/copenhague" },
      { id: 4, title: "Miami-Splau", path: "/caja/miami" },
      { id: 5, title: "Make Up 400", path: "/caja/make-up-400" },
      // { id: 5, title: "Tiendas Top", path: "/caja/tiendas-top" },
      // { id: 6, title: "Tiendas Light/Low", path: "/caja/tiendas-light-low" },
    ],
  },
  {
    id: 7,
    title: "Dotación",
    path: "/dotacion",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/dotacion/todo" },
      { id: 2, title: "Munich", path: "/dotacion/munich" },
      { id: 3, title: "Copenhague", path: "/dotacion/copenhague" },
      { id: 4, title: "Miami-Splau", path: "/dotacion/miami" },
      { id: 5, title: "Make Up 400", path: "/dotacion/make-up-400" },
      // { id: 5, title: "Muebles Sueltos", path: "/dotacion/lista-dotaciones" },
    ],
  },
  {
    id: 8,
    title: "Instalaciones",
    path: "/instalaciones",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/instalaciones/todo" },
      { id: 2, title: "Munich", path: "/instalaciones/munich" },
      { id: 3, title: "Copenhague", path: "/instalaciones/copenhague" },
      { id: 4, title: "Miami-Splau", path: "/instalaciones/miami" },
      { id: 5, title: "Make Up 400", path: "/instalaciones/make-up-400" },
    ],
  },
  {
    id: 9,
    title: "Señalética",
    path: "/senaletica",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/senaletica/todo" },
      { id: 2, title: "Munich", path: "/senaletica/munich" },
      { id: 3, title: "Copenhague", path: "/senaletica/copenhague" },
      { id: 4, title: "Miami-Splau", path: "/senaletica/miami" },
      { id: 5, title: "Make Up 400", path: "/senaletica/make-up-400" },
      // { id: 5, title: "Banners", path: "/senaletica/banners" },
      // { id: 6, title: "Señalización", path: "/senaletica/señalizacion" },
      // { id: 7, title: "Top/Light/Low", path: "/senaletica/top-light-low" },
    ],
  },
  {
    id: 10,
    title: "Boh",
    path: "/boh",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/boh/todo" },
      { id: 2, title: "Munich", path: "/boh/munich" },
      { id: 3, title: "Copenhague", path: "/boh/copenhague" },
      { id: 4, title: "Miami-Splau", path: "/boh/miami" },
      { id: 5, title: "Make Up 400", path: "/boh/make-up-400" },
    ],
  },
  {
  id: 11,
  title: "Dotaciones fijas por tienda",
  path: "/dotaciones-fijas",
  hasSubMenu: true,
  subMenuItems: [
    { id: 1, title: "Todo", path: "/dotaciones-fijas/todo" },
    { id: 2, title: "Munich", path: "/dotaciones-fijas/munich" },
    { id: 3, title: "Copenhague", path: "/dotaciones-fijas/copenhague" },
    { id: 4, title: "Make Up 400", path: "/dotaciones-fijas/make-up-400" },
    { id: 5, title: "Make Up 400 PLUS", path: "/dotaciones-fijas/make-up-400-plus" },
    { id: 6, title: "Miami-Splau", path: "/dotaciones-fijas/miami" },
  ],
  },
  {
    id: 12,
    title: "Detalles constructivos",
    path: "/detalles-constructivos",
    hasSubMenu: true,
    isSeparatedGroup: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/detalles-constructivos/todo" },
      { id: 2, title: "Munich", path: "/detalles-constructivos/munich" },
      { id: 3, title: "Copenhague", path: "/detalles-constructivos/copenhague" },
      { id: 4, title: "Make Up 400", path: "/detalles-constructivos/make-up-400" },
      { id: 5, title: "Miami-Splau", path: "/detalles-constructivos/miami" },
    ],
  },
  {
    id: 13,
    title: "Detalles instalaciones",
    path: "/detalles-instalaciones",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/detalles-instalaciones/todo" },
      { id: 2, title: "Munich", path: "/detalles-instalaciones/munich" },
      { id: 3, title: "Copenhague", path: "/detalles-instalaciones/copenhague" },
      { id: 4, title: "Make Up 400", path: "/detalles-instalaciones/make-up-400" },
      { id: 5, title: "Miami-Splau", path: "/detalles-instalaciones/miami" },
    ],
  },
  {
    id: 14,
    title: "Montaje de mobiliario",
    path: "/montaje-mobiliario",
    hasSubMenu: true,
    subMenuItems: [
      { id: 1, title: "Todo", path: "/montaje-mobiliario/todo" },
      { id: 2, title: "Munich", path: "/montaje-mobiliario/munich" },
      { id: 3, title: "Copenhague", path: "/montaje-mobiliario/copenhague" },
      { id: 4, title: "Make Up 400", path: "/montaje-mobiliario/make-up-400" },
      { id: 5, title: "Miami-Splau", path: "/montaje-mobiliario/miami" },
    ],
  },
];

export default menuItems;
